// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInvoiceSummaryRecordDto } from './IInvoiceSummaryRecordDto';
import {
    IInvoiceSummaryRecordDtoFromJSON,
    IInvoiceSummaryRecordDtoFromJSONTyped,
    IInvoiceSummaryRecordDtoToJSON,
    IInvoiceSummaryRecordDtoToJSONTyped,
} from './IInvoiceSummaryRecordDto';
import type { IReportSummaryGroupDtoInvoiceSummaryRecordDto } from './IReportSummaryGroupDtoInvoiceSummaryRecordDto';
import {
    IReportSummaryGroupDtoInvoiceSummaryRecordDtoFromJSON,
    IReportSummaryGroupDtoInvoiceSummaryRecordDtoFromJSONTyped,
    IReportSummaryGroupDtoInvoiceSummaryRecordDtoToJSON,
    IReportSummaryGroupDtoInvoiceSummaryRecordDtoToJSONTyped,
} from './IReportSummaryGroupDtoInvoiceSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryDtoInvoiceSummaryRecordDto
 */
export interface IReportSummaryDtoInvoiceSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryDtoInvoiceSummaryRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {Array<IInvoiceSummaryRecordDto>}
     * @memberof IReportSummaryDtoInvoiceSummaryRecordDto
     */
    employer_records?: Array<IInvoiceSummaryRecordDto>;
    /**
     * 
     * @type {Array<IReportSummaryGroupDtoInvoiceSummaryRecordDto>}
     * @memberof IReportSummaryDtoInvoiceSummaryRecordDto
     */
    subsidiary_groups?: Array<IReportSummaryGroupDtoInvoiceSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryDtoInvoiceSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryDtoInvoiceSummaryRecordDto(value: object): value is IReportSummaryDtoInvoiceSummaryRecordDto {
    return true;
}

export function IReportSummaryDtoInvoiceSummaryRecordDtoFromJSON(json: any): IReportSummaryDtoInvoiceSummaryRecordDto {
    return IReportSummaryDtoInvoiceSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryDtoInvoiceSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryDtoInvoiceSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_records': json['employer_records'] == null ? undefined : ((json['employer_records'] as Array<any>).map(IInvoiceSummaryRecordDtoFromJSON)),
        'subsidiary_groups': json['subsidiary_groups'] == null ? undefined : ((json['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoInvoiceSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryDtoInvoiceSummaryRecordDtoToJSON(json: any): IReportSummaryDtoInvoiceSummaryRecordDto {
    return IReportSummaryDtoInvoiceSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryDtoInvoiceSummaryRecordDtoToJSONTyped(value?: IReportSummaryDtoInvoiceSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_name': value['employer_name'],
        'employer_records': value['employer_records'] == null ? undefined : ((value['employer_records'] as Array<any>).map(IInvoiceSummaryRecordDtoToJSON)),
        'subsidiary_groups': value['subsidiary_groups'] == null ? undefined : ((value['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoInvoiceSummaryRecordDtoToJSON)),
    };
}

